import { render, staticRenderFns } from "./trendAnalysis.vue?vue&type=template&id=35ea40df&scoped=true"
import script from "./trendAnalysis.vue?vue&type=script&lang=js"
export * from "./trendAnalysis.vue?vue&type=script&lang=js"
import style0 from "./trendAnalysis.vue?vue&type=style&index=0&id=35ea40df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ea40df",
  null
  
)

export default component.exports